import * as Redux from 'redux';

import { paymentActions } from '../../../weborder/redux/payment';
import { fdApi } from '../../api';
import {
  AddUserPayGreenVoucher,
  CategorizedMenuItemsResponse,
  SavedRestaurantVoucher,
  UserSavedRestaurantVouchers,
} from './payment.types';

const addUserPayGreenVoucher = (
  payGreenVoucherScheme: string,
  storeId: number,
) => (): Promise<AddUserPayGreenVoucher> => {
  const requestPayload = {
    payGreenVoucherScheme,
    storeId,
  };

  return fdApi
    .use(fdApi.payment.postAddUserPayGreenVoucher(requestPayload))
    .then((data: AddUserPayGreenVoucher) => data);
};

const getUserSavedRestaurantVouchers = (storeId: number) => (
  dispatch: Redux.Dispatch<Redux.Action>,
): Promise<void> =>
  fdApi
    .use(fdApi.payment.getUserSavedRestaurantVouchers(storeId))
    .then((data: UserSavedRestaurantVouchers) => {
      dispatch(
        paymentActions.setRestaurantVouchers({
          data,
          status: 'success',
          storeId,
        }),
      );
    })
    .catch(() => {
      dispatch(
        paymentActions.setRestaurantVouchers({
          status: 'none',
          storeId,
        }),
      );
    });

const getUserSavedRestaurantVoucherStatus = (
  paymentAccountId: number,
  storeId: number,
) => (dispatch: Redux.Dispatch<Redux.Action>): Promise<void> =>
  fdApi
    .use(
      fdApi.payment.getUserSavedRestaurantVoucherStatus(
        paymentAccountId,
        storeId,
      ),
    )
    .then((data: SavedRestaurantVoucher) => {
      dispatch(
        paymentActions.addSavedRestaurantVoucher({
          data,
          status: 'success',
          storeId,
        }),
      );
    })
    .catch(() => {
      dispatch(
        paymentActions.addSavedRestaurantVoucher({
          status: 'none',
          storeId,
        }),
      );
    });

const retrieveCategorizeMenuitems = (menuItemIds: number[]) => (
  dispatch: Redux.Dispatch<Redux.Action>,
): Promise<void> =>
  fdApi
    .use(fdApi.payment.postCategorizeMenuitems({ MenuItemIds: menuItemIds }))
    .then((data: CategorizedMenuItemsResponse) => {
      dispatch(
        paymentActions.setCanApplyRestaurantVoucher({
          data,
          status: 'success',
        }),
      );
    })
    .catch(() => {
      dispatch(
        paymentActions.setCanApplyRestaurantVoucher({
          status: 'none',
        }),
      );
    });

export const paymentMiddleware = {
  addUserPayGreenVoucher,
  getUserSavedRestaurantVoucherStatus,
  getUserSavedRestaurantVouchers,
  retrieveCategorizeMenuitems,
};
